export default "__VITE_ASSET__TXxM47lW__"